module.exports = "/images/Canada.png?9dffa0d8d66ae04088f8b6384b998e95";